// extracted by mini-css-extract-plugin
module.exports = {"ContentBlock":"ContentBlock_ContentBlock__9o_zS","LimitWidth":"ContentBlock_LimitWidth__GaXLh","Title":"ContentBlock_Title__oEuTb","Description":"ContentBlock_Description__S95NZ"};